import { Box, IconButton, Typography } from '@mui/material'
import Icon, { CloseIcon } from '@design-systems/react-icons'
import TuneIcon from '@mui/icons-material/Tune'
import { grey } from '@mui/material/colors'
import { drawerHeaderSx } from '../styles/NotificationStyle'

export default function NotificationHeader({
  viewFilter,
  readStatusFilter,
  onFilterClick,
  onClose,
}) {
  return (
    <Box sx={drawerHeaderSx}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Notifications
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton
          size="small"
          onClick={onFilterClick}
          sx={{
            color: '#666',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          <TuneIcon />
        </IconButton>
        <IconButton size="small" onClick={onClose}>
          <Icon svg={CloseIcon} size="sm" style={{ color: grey[600] }} />
        </IconButton>
      </Box>
    </Box>
  )
}
